import wx from 'weixin-js-sdk';
import StorageUtil from './storage-util';
import { SystemConst } from './constant';

const MINI_RESTORE_FLAG = 'ysdhMiniRestoreTried';
const MINI_RESTORE_APPLIED_FLAG = 'ysdhMiniRestoreApplied';
const MINI_AUTH_SYNCED_PARAM = 'mp_auth_synced';
const MINI_WEBVIEW_PAGE = '/pages/frame/index'; // 小程序承载 H5 的页面路径

function safeGet(key) {
  try {
    return StorageUtil.getItem(key);
  } catch (e) {
    return null;
  }
}

function isMiniProgram(callback) {
  if (window.__wxjs_environment === 'miniprogram') {
    callback(true);
    return;
  }

  if (wx && wx.miniProgram && wx.miniProgram.getEnv) {
    wx.miniProgram.getEnv(res => callback(!!res.miniprogram));
    return;
  }

  callback(false);
}

function cleanCurrentUrl() {
  const url = new URL(window.location.href);
  url.searchParams.delete('auth_code_');
  url.searchParams.delete('mp_restore');
  url.searchParams.delete('mp_restore_failed');
  return url.toString();
}

/**
 * 检查URL中是否有mp_restore_failed标记（小程序restore失败时传递）
 * @returns {boolean} true表示restore已失败，不应再尝试
 */
function hasRestoreFailedFlag() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.has('mp_restore_failed');
}

function hasMiniAuthSyncedFlag() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(MINI_AUTH_SYNCED_PARAM) === '1' || urlParams.get('mp_restore') === '1';
}

export function markMiniProgramRestoreApplied() {
  try {
    sessionStorage.setItem(MINI_RESTORE_APPLIED_FLAG, '1');
  } catch (err) {}
}

export function clearMiniProgramRestoreApplied() {
  try {
    sessionStorage.removeItem(MINI_RESTORE_APPLIED_FLAG);
  } catch (err) {}
}

export function isMiniProgramRestoreApplied() {
  if (window.location.search && window.location.search.indexOf('mp_restore=1') > -1) return true;
  try {
    return sessionStorage.getItem(MINI_RESTORE_APPLIED_FLAG) === '1';
  } catch (err) {
    return false;
  }
}

/**
 * H5登录成功后，同步auth_code给小程序保存
 * @param {string} rawAuthCode - 原始auth_code（Base64编码，未URL解码）
 * @param {object} loginUser - 解析后的登录用户信息
 */
export function syncAuthToMiniProgram(rawAuthCode, loginUser) {
  if (!rawAuthCode || !loginUser) return;

  isMiniProgram(isMini => {
    if (!isMini || !wx.miniProgram) return;

    wx.miniProgram.postMessage({
      data: {
        type: 'YSDH_H5_AUTH_SYNC',
        version: 1,
        companyId: loginUser.company_id_,
        authCode: rawAuthCode,
        currentUrl: cleanCurrentUrl(),
        expiresIn: loginUser.expires_in,
        ts: Date.now()
      }
    });
  });
}

/**
 * 退出登录时，通知小程序清除保存的auth_code
 * @param {string|number} companyId - 公司ID
 */
export function clearMiniProgramAuth(companyId) {
  isMiniProgram(isMini => {
    if (!isMini || !wx.miniProgram) return;

    wx.miniProgram.postMessage({
      data: {
        type: 'YSDH_H5_AUTH_CLEAR',
        companyId,
        ts: Date.now()
      }
    });
  });
}

/**
 * H5存储丢失时，尝试让小程序恢复auth_code
 * 当token或ysUser不存在时，请求小程序重新注入auth_code
 */
export function tryRestoreFromMiniProgram() {
  const token = safeGet(SystemConst.token);
  const ysUser = safeGet(SystemConst.mShop_user);

  // 本地有token和用户信息，不需要恢复
  if (token && ysUser) return;
  if (!hasMiniAuthSyncedFlag()) return;

  // 关键：如果URL中有mp_restore_failed标记，说明小程序已经尝试恢复但失败了
  // 此时不应再跳小程序restore，否则会形成循环跳转
  if (hasRestoreFailedFlag()) {
    console.log('tryRestoreFromMiniProgram===>小程序restore已失败，不再尝试');
    return;
  }

  isMiniProgram(isMini => {
    if (!isMini || !wx.miniProgram) return;
    // 防止重复恢复尝试
    if (sessionStorage.getItem(MINI_RESTORE_FLAG)) {
      console.log('tryRestoreFromMiniProgram===>已尝试过restore，sessionStorage标记存在');
      return;
    }

    sessionStorage.setItem(MINI_RESTORE_FLAG, '1');
    console.log('tryRestoreFromMiniProgram===>开始请求小程序restore');

    const url = `${MINI_WEBVIEW_PAGE}?restore=1&target=${encodeURIComponent(cleanCurrentUrl())}&ts=${Date.now()}`;

    wx.miniProgram.redirectTo({
      url,
      fail() {
        wx.miniProgram.navigateTo({ url });
      }
    });
  });
}



// WEBPACK FOOTER //
// ./src/utils/mini-program-auth-sync.js